import { Card, CardContent } from '@/components/ui/card';

export interface MetricCardItem {
  label: string;
  value: string;
  /** Small caption shown under the value — use to be explicit about a metric's period/source. */
  hint?: string;
}

/**
 * Metric cards row for the Engagement section (parity DetailsScreen.kt:424-443
 * `adminMetricsCards`). CMP hardcoded 4 demo values here ("Total Visits" 367K, "Subscribers" 7210,
 * "Total Received" 721K, "Total Contents" 36) — this port renders whatever real metrics the caller
 * computed from the /statistics endpoints + top-content totals (see EngagementSection). No
 * fabricated numbers: a metric with no backend source simply isn't passed in.
 */
export function MetricCardsRow({ metrics }: { metrics: MetricCardItem[] }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {metrics.map((m) => (
        <Card key={m.label}>
          <CardContent className="p-4">
            <p className="text-xs text-muted-foreground">{m.label}</p>
            <p className="mt-1 text-lg font-semibold">{m.value}</p>
            {m.hint && (
              <p className="mt-0.5 text-[10px] uppercase tracking-wide text-muted-foreground">
                {m.hint}
              </p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
